import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`consig`, `/regra_tabela_comissionamentos/${id}`)
}
export async function getRegras (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamento?` + serialize(dados), 'GET')
}
export async function listRegrasMinimo () {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamento?all=1`)
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/regra_tabela_comissionamentos/PostEnvelopado`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`consig`, `/regra_tabela_comissionamentos/`, 'PUT', dados)
}
export async function delRegra (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamento/${dados}`, 'DELETE')
}
export async function getGerais (dados) {
  return sessaoFetchLoading(`consig`, `/regra_tabela_comissionamentos/ListarPaginadoQueryEnvelopado?` + serialize(dados), 'GET', dados)
}
export async function editStatusGerais (dados) {
  return sessaoFetchLoading(`consig`, `/regra_tabela_comissionamentos/ativo`, 'PUT', dados)
}
export async function getRegrasSelect (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamento?all=1`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/regras.js